import { render, staticRenderFns } from "./WidgetLink.vue?vue&type=template&id=5d6bba0a&lang=pug"
import script from "./WidgetLink.vue?vue&type=script&lang=js"
export * from "./WidgetLink.vue?vue&type=script&lang=js"
import style0 from "./WidgetLink.vue?vue&type=style&index=0&id=5d6bba0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VHover,VIcon,VTooltip})
